import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { Helmet } from "react-helmet-async";

const Identifikasiaksess = () => {
  const location = useLocation();
  const phonenumber = location.state?.phonenumber || '';
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [nama, setNama] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [informasiAkun, setInformasiAkun] = useState(null); // State untuk menyimpan informasi akun

  const npsn = searchParams.get("npsn");
  const [formdata, setFormData] = useState({
    npsn: npsn,
    kodeaksess: ''
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(``);
    // Pastikan formdata tidak null atau undefined
    if (!formdata || Object.keys(formdata).length === 0) {
      setError('Data tidak boleh kosong');
      return;
    }
    console.log(localStorage.getItem("token"))

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/registrasiweb/kodeaksess`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
       
        body: JSON.stringify(formdata),
      });const result = await response.json();
      if (!response.ok) {
                throw new Error(result.message || "Gagal menyimpan data");
            }
      
      
      const data = result;

      
        localStorage.setItem('token', data.token);
      console.log(data)

      const step = data.step;
      if (step == 1) {
        navigate("/daftar/identifikasisekolah");
      } else if (step == 2) {
        navigate("/daftar/identifikasiaksess?npsn=" + data.data.npsn);
      } else if (step == 3) {
       if (data.data.akses == "Pendidik") {
          navigate("/Pendidik");
        } else if (data.data.akses == "Operator") {
          navigate("/admin");
        } else if (data.data.akses == "Pd") {
          navigate("/daftar/formBiodatapd?nama="+data.data.nama);
        } else {
          navigate("/daftar/identifikasisekolah");
        }
      } else {
        if (data.data.akses == "Pendidik") {
          navigate("/Pendidik");
        } else if (data.data.akses == "Operator") {
          navigate("/admin");
        } else {
          navigate("/daftar/identifikasisekolah");
        }
      }
    } catch (error) {
      setError(`Terjadi kesalahan: ${error.message}`);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formdata, [e.target.name]: e.target.value });
  };




  return (
    <div>
      <Helmet>
        <title>Identifikasi Pengguna</title>
      </Helmet>
      <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
        <div className="card shadow p-4" style={{ width: "100%", maxWidth: "420px" }}>
          <div className="text-center mb-4">
            <img
              src="/assets/images/logogvfix.png"
              width={100}
              alt="Logo"
              className="img-fluid mb-2"
            />
            <h4 className="text-secondary mt-3"><b>Hi, Selamat Datang</b></h4>
            <p className="text-muted">Lengkapi Biodata</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-floating mb-3">
              <input
                type="text"
                name='npsn'
                readOnly
                required
                value={formdata.npsn}
                onChange={(e) => handleChange(e)}
                className="form-control"
                placeholder="NPSN"
              />
              <label htmlFor="floatingNama">NPSN Sekolah {formdata.nspn} s</label>
            </div>
            <div className="form-floating mb-3">
              <input
                type="text"
                name='kodeaksess'
                required
                value={formdata.kodeaksess}
                onChange={(e) => handleChange(e)}
                className="form-control"

                placeholder="Kode Registrasi"
              />
              <label htmlFor="floatingNama">Reg Kode</label>
            </div>
            {/* <div className="form-floating mb-3">
                    <input 
                      type="text"
                      value={formdata.noi}
                      name='noi'
                     
                      onChange={(e) => handleChange(e)} 
                      className="form-control" 
                      placeholder="No Induk Pegawai" 
                    />
                    <label htmlFor="floatingNama">No Induk Pegawai (Jika tidak ada Koosngkan Saja)</label>
                  </div>
                   */}

            <div className="d-grid mt-4">
              <button type="submit" className="btn btn-secondary">Lanjutkan</button>
            </div>
          </form>

          {error && <div className="alert alert-danger mt-2">{error}</div>}
          {successMessage && <div className="alert alert-success mt-2">{successMessage}</div>}

          <hr />
        </div>
      </div>
    </div>
  );
};

export default Identifikasiaksess;
